import StatusScreenScaffold from "../../../../components/layout/StatusScreenScaffold";
import { StatusScreenType } from "../../../../components/layout/StatusScreenScaffold/types";

function ProposalInvalidToken() {
  return (
    <StatusScreenScaffold
      title="Token não validado!"
      subtitle="Erro ao validar o token. Tente novamente ou entre em contato com nosso suporte."
      subtitleMaxWidth={300}
      type={StatusScreenType.error}
    />
  );
}
export default ProposalInvalidToken;
